<template>
    <div>
        <NewsCenterTop />
        <div class="titleStyle">
            <div class="titleFont">基金会要闻</div>
            <div class="conentFont">
                <div class="divide"></div>
                <span class="enFont">MEDIA ATTENTION</span>
                <div class="divide"></div>
            </div>
        </div>
        <div
            class="listStyle"
            v-for="(item, idx) in listInfo"
            :key="idx"
            @click="findDetail(item)"
        >
            <div class="itemLeft">
                <img :src="item.image" />
            </div>
            <div class="itemRight">
                <div class="itemTitle">
                    <div class="titleLeft">
                        {{ item.title }}
                    </div>
                    <div class="titleRight">{{ item.publishTime }}</div>
                </div>
                <div class="itemContent">
                    {{ item.description }}
                </div>
            </div>
        </div>
        <div class="paginationStyle">
            <a-pagination
                :default-current="1"
                :defaultPageSize="5"
                :total="total"
                :hideOnSinglePage="true"
                @change="changePage"
            />
        </div>
    </div>
</template>
<script>
import NewsCenterTop from "@/components/NewsCenterTop.vue";
import { getAction } from "@/api/services";
export default {
    name: "MediaAttention",
    components: {
        NewsCenterTop,
    },
    data() {
        return {
            url: "/jhwlweb/gwweb/cmsArticleCategory/queryNewsList",
            pageNo: 1,
            pageSize: 5,
            total: undefined,
            listInfo: [],
        };
    },
    created() {
        this.getInfo();
    },
    methods: {
        findDetail(item) {
            if (item.showLink == 1) {
                window.open(item.link);
                return;
            } else {
                this.$router.push({
                    name: "NewsCenterDetail",
                    params: item,
                });
            }
        },
        changePage(page) {
            this.pageNo = page;
            this.getInfo();
        },
        getInfo() {
            let that = this;
            let parmas = {
                menuCategory: 170,
                pageNo: that.pageNo,
                pageSize: that.pageSize,
            };
            getAction(that.url, parmas).then((res) => {
                if (res.code == 200 && res.success) {
                    that.total = res.result.total;
                    that.listInfo = res.result.records;
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
.typeArea {
    max-width: 1100px;
    margin: 0 auto;
}
.titleStyle {
    .typeArea();
    padding-bottom: 80px;
    padding-top: 90px;
    text-align: center;
    width: 100%;
    .titleFont {
        font-family: "阿里巴巴普惠体";
        font-size: 32px;
        line-height: 28px;
        letter-spacing: 2px;
        color: #333333;
    }
    .conentFont {
        margin-top: 8px;
        .divide {
            display: inline-block;
            vertical-align: super;
            width: 20px;
            height: 2px;
            background-color: #0052d9;
        }
        .enFont {
            margin: 0 10px;
            font-family: "微软雅黑";
            font-size: 16px;
            letter-spacing: 0px;
            color: #333333;
            opacity: 0.5;
        }
    }
}
.oneOmit {
    white-space: nowrap; /*强调在同一行内显示所有文字，知道文本结束或者遭到br换行*/
    overflow: hidden; /*超出部分隐藏*/
    text-overflow: ellipsis; /*溢出部分用省略号代替*/
}
.listStyle {
    .typeArea();
    padding: 15px 20px;
    border-bottom: 1px solid #e1e1e1;
    display: flex;
    align-items: center;
    cursor: pointer;
    .itemLeft {
        width: 25%;
        height: 180px;
        display: flex;
        align-items: center;
        img {
            width: 100%;
        }
    }
    .itemRight {
        padding: 15px;
        width: 75%;
        display: flex;
        flex-wrap: wrap;
        .itemTitle {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .titleLeft {
                .oneOmit();
                width: 80%;
                font-family: "黑体";
                font-size: 24px;
                letter-spacing: 0px;
                color: #333333;
            }
            .titleRight {
                width: 20%;
                text-align: right;
                font-size: 18px;
                letter-spacing: 0px;
                color: #999999;
            }
        }
        .itemContent {
            word-break: break-all;
            display: -webkit-box; /**对象作为伸缩盒子模型展示**/
            -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
            -webkit-line-clamp: 3; /**显示的行数**/
            overflow: hidden; /**隐藏超出的内容**/
            width: 90%;
            margin-top: 1rem;
            font-size: 16px;
            letter-spacing: 0px;
            color: #999999;
        }
        .more {
            margin-top: 1rem;
            width: 100%;
            font-size: 16px;
            letter-spacing: 0px;
            color: #999999;
            text-align: right;
            cursor: pointer;
        }
    }
}
.listStyle:hover {
    box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.2);
}
.paginationStyle {
    padding-top: 120px;
    padding-bottom: 60px;
    text-align: center;
}
</style>